import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-ds-bg px-4">
      <h1 className="text-7xl font-semibold text-ds-text">404</h1>
      <p className="mt-4 max-w-md text-center text-base text-ds-muted">{t('app.error_generic')}</p>
      <div className="mt-8">
        <Link to="/dashboard">
          <Button>{t('nav.dashboard')}</Button>
        </Link>
      </div>
    </div>
  );
}
